import { Admin, Resource, CustomRoutes } from 'react-admin';
import { Route } from 'react-router-dom';

import { authProvider } from './providers/authProvider.js';
import { dataProvider } from './providers/dataProvider.js';
import { mlisTheme } from './theme.js';
import { Dashboard } from './Dashboard.jsx';
import { MlisLayout } from './components/Layout.jsx';
import { LoginPage } from './components/LoginPage.jsx';
import { Help } from './components/Help.jsx';

import slides from './resources/slides/index.js';
import stats from './resources/stats/index.js';
import features from './resources/features/index.js';
import levelCards from './resources/level-cards/index.js';
import news from './resources/news/index.js';
import events from './resources/events/index.js';
import achievements from './resources/achievements/index.js';
import galleryAlbums from './resources/gallery-albums/index.js';
import galleryImages from './resources/gallery-images/index.js';
import addresses from './resources/addresses/index.js';
import partners from './resources/partners/index.js';
import leadershipMessages from './resources/leadership-messages/index.js';
import faculty from './resources/faculty/index.js';
import careers from './resources/careers/index.js';
import calendar from './resources/calendar/index.js';
import alumni from './resources/alumni/index.js';
import pages from './resources/pages/index.js';
import siteSettings from './resources/site-settings/index.js';
import admissionEnquiries from './resources/admission-enquiries/index.js';
import admissionClasses from './resources/admission-classes/index.js';
import contactSubmissions from './resources/contact-submissions/index.js';
import newsletterSubscribers from './resources/newsletter-subscribers/index.js';
import users from './resources/users/index.js';
import activityLogs from './resources/activity-logs/index.js';
import menuItems from './resources/menu-items/index.js';
import campuses from './resources/campuses/index.js';
import facilities from './resources/facilities/index.js';
import homeWelcome from './resources/home-welcome/index.js';
import homeAdvantage from './resources/home-advantage/index.js';
import homePopup from './resources/home-popup/index.js';
import alumniRegistrations from './resources/alumni-registrations/index.js';

export const App = () => (
  <Admin
    title="MLIS Admin"
    authProvider={authProvider}
    dataProvider={dataProvider}
    dashboard={Dashboard}
    layout={MlisLayout}
    loginPage={LoginPage}
    theme={mlisTheme}
    requireAuth
    disableTelemetry
  >
    {(permissions) => {
      const isSuper = permissions === 'super_admin';
      return [
        // ---- Help page (custom route, not a data resource) ----
        <CustomRoutes key="custom-routes">
          <Route path="/help" element={<Help />} />
        </CustomRoutes>,

        // ---- Homepage content ----
        <Resource key="home-welcome" name="home-welcome" {...homeWelcome} />,
        <Resource key="home-advantage" name="home-advantage" {...homeAdvantage} />,
        <Resource key="home-popup" name="home-popup" {...homePopup} />,
        <Resource key="slides" name="slides" {...slides} />,
        <Resource key="stats" name="stats" {...stats} />,
        <Resource key="features" name="features" {...features} />,
        <Resource key="level-cards" name="level-cards" {...levelCards} />,
        <Resource key="leadership-messages" name="leadership-messages" {...leadershipMessages} />,
        <Resource key="partners" name="partners" {...partners} />,
        <Resource key="campuses" name="campuses" {...campuses} />,
        <Resource key="facilities" name="facilities" {...facilities} />,

        // ---- Editorial ----
        <Resource key="news" name="news" {...news} />,
        <Resource key="events" name="events" {...events} />,
        <Resource key="achievements" name="achievements" {...achievements} />,

        // ---- Gallery ----
        <Resource key="gallery-albums" name="gallery-albums" {...galleryAlbums} />,
        <Resource key="gallery-images" name="gallery-images" {...galleryImages} />,

        // ---- Static-ish ----
        <Resource key="pages" name="pages" {...pages} />,
        <Resource key="calendar" name="calendar" {...calendar} />,
        <Resource key="faculty" name="faculty" {...faculty} />,
        <Resource key="careers" name="careers" {...careers} />,
        <Resource key="alumni" name="alumni" {...alumni} />,
        <Resource key="addresses" name="addresses" {...addresses} />,

        // ---- Inbox / submissions ----
        <Resource key="admission-enquiries" name="admission-enquiries" {...admissionEnquiries} />,
        <Resource key="alumni-registrations" name="alumni-registrations" {...alumniRegistrations} />,
        <Resource key="contact-submissions" name="contact-submissions" {...contactSubmissions} />,
        <Resource key="newsletter-subscribers" name="newsletter-subscribers" {...newsletterSubscribers} />,

        // ---- Super-admin only ----
        isSuper ? <Resource key="menu-items" name="menu-items" {...menuItems} /> : null,
        isSuper ? <Resource key="site-settings" name="site-settings" {...siteSettings} /> : null,
        isSuper ? <Resource key="admission-classes" name="admission-classes" {...admissionClasses} /> : null,
        isSuper ? <Resource key="users" name="users" {...users} /> : null,
        isSuper ? <Resource key="activity-logs" name="activity-logs" {...activityLogs} /> : null,
      ];
    }}
  </Admin>
);
